module.exports = __webpack_public_path__ + "img/mv.3c896bfd.svg";